var map = {
	"./de-de.json": 1340,
	"./en-us.json": 1341,
	"./id.json": 1342,
	"./ja.json": 1343,
	"./ko.json": 1344,
	"./vi.json": 1345,
	"./whitelists/whitelist_de-de.json": 1346,
	"./whitelists/whitelist_en-us.json": 1347,
	"./whitelists/whitelist_id.json": 1348,
	"./whitelists/whitelist_ja.json": 1349,
	"./whitelists/whitelist_ko.json": 1350,
	"./whitelists/whitelist_vi.json": 1351,
	"./whitelists/whitelist_zh-cn.json": 1352,
	"./whitelists/whitelist_zh-tw.json": 1353,
	"./zh-cn.json": 1354,
	"./zh-tw.json": 1355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813;